var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCommentNewIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.16699 9.16675C2.16699 6.83704 2.16699 5.67219 2.54759 4.75333C3.05506 3.52819 4.02843 2.55482 5.25358 2.04735C6.17243 1.66675 7.33728 1.66675 9.66699 1.66675H10.8337C13.6339 1.66675 15.034 1.66675 16.1036 2.21172C17.0444 2.69108 17.8093 3.45599 18.2887 4.3968C18.8337 5.46635 18.8337 6.86649 18.8337 9.66675V15.9757C18.8337 16.4452 18.8337 16.68 18.7988 16.8387C18.6076 17.7109 17.7015 18.2239 16.8553 17.9391C16.7013 17.8873 16.5 17.7665 16.0974 17.525V17.525C15.8565 17.3805 15.7361 17.3082 15.6138 17.2438C14.9776 16.9083 14.2764 16.7141 13.5582 16.6744C13.4202 16.6667 13.2798 16.6667 12.9989 16.6667H9.66699C7.33728 16.6667 6.17243 16.6667 5.25358 16.2861C4.02843 15.7787 3.05506 14.8053 2.54759 13.5802C2.16699 12.6613 2.16699 11.4965 2.16699 9.16675V9.16675Z",
    stroke: "#23252F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCommentNewIcon);
export default ForwardRef;